<template>
	<div :class="['spin-result-modal', 'marquee-light-border', `${borderType}-border`]">
		<div class="modal-overflow">
			<div class="modal-content">
				<component :is="subComponent" v-bind="data" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Big from "@/components/game/spin/bummers/Big";
import Little from "@/components/game/spin/bummers/Little";
import Jackpot from "@/components/game/spin/bummers/Jackpot";
import Trivia from "@/components/game/spin/bummers/Trivia";

export default {
	name: 'SpinResultModal',
	components: {
		Big,
		Little,
		Jackpot,
		Trivia,
	},
	computed: {
		...mapState({
			data: (state) => state.global.modal.data,
		}),
		subComponent() {
			return this.data.model.charAt(0).toUpperCase() + this.data.model.slice(1);
		},
		borderType() {
			return this.subComponent.toLowerCase();
		},
	},
	methods: {
		...mapActions({
			deactivateModal: "global/modal/deactivate",
		}),
		async complete() { // called from within child components
			await this.$store.dispatch("game/bummers/active/complete");

			if (this.$store.state.game.balance.amount <= 0) {
				this.$router.push("/game/complete");
			} else if (
				this.$store.state.game.rounds.active.spinsRemaining === 0
				&& this.$store.getters["game/rounds/hasNextRound"] === false
			) {
				this.$router.push("/game/rounds/complete");
			} else if (this.$store.state.game.rounds.active.spinsRemaining === 0) {
				this.deactivateModal();
				this.$store.dispatch("game/rounds/active/activateBonus");
			} else {
				this.deactivateModal();
			}

			this.$store.dispatch("sound/fx/play", { id: "button_generic" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.spin-result-modal {
		height: 435px;
		width: 300px;
		background: $primary-color-dark;
		color: white;
		display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

		@include tablet {
			height: 700px;
			width: 550px;
		}

		@include desktop {
			height: 600px;
			width: 750px;
		}

		@include desktop-sm {
			height: 500px;
			width: 675px;
		}
	}

	// this triple div thing is kinda gross, but it's necessary
	// to allow the inner div to scroll. (It's not *necessary* per se, i.e.
	// there is a better way to handle this by not using flex for display,
	// but we're too far gone to rewrite this properly.)

	.modal-overflow {
		max-height: 100%;
		overflow: scroll;
		text-align: center;
		overflow-x: hidden;
		width: 100%;
		// -ms-overflow-style: -ms-autohiding-scrollbar;
		-ms-overflow-style: none;
	}

	.modal-content {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 80%;
		margin: 40px auto;

		@include desktop { width: 65%; }
	}
</style>
